import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Row, Col } from 'react-bootstrap';
import { getProduits } from 'data/produits';
import Select from 'react-select';
import { IoSyncOutline } from 'react-icons/io5';
import PropTypes from 'prop-types';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';

const ProduitAjout = ({
  setShow,
  Produits,
  AjouterProduit,
  setModalShow,
  setRefresh,
  produitAModifier,
  typeOperation,
  ModifierProduit
}) => {
  const [selectedProduit, setSelectedProduit] = useState({
    quantite: 1
  });
  useEffect(() => {
    console.log('produit a modifier :', produitAModifier);
    console.log('type operation :', typeOperation);
    if (typeOperation === 'modification') {
      setSelectedProduit(produitAModifier);
    } else {
      setSelectedProduit({
        quantite: 1
      });
    }
  }, [produitAModifier]);

  return (
    <Card className="mt-3 mb-3">
      <Card.Body>
        <Form>
          <Row className="d-flex justify-content-between align-items-center">
            <Col style={{ marginRight: '-20px', alignItems: 'center' }}>
              <Button onClick={() => setModalShow(true)}>Créer</Button>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Code</Form.Label>
                <Form.Control
                  type="text"
                  disabled
                  value={selectedProduit.value || ''}
                />
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group className="mb-3">
                <Form.Label>Produit</Form.Label>
                <div className="d-flex align-items-center">
                  <Select
                    className="basic-single flex-grow-1"
                    classNamePrefix="basic-single"
                    placeholder="sélectionner un produit"
                    isClearable
                    isSearchable
                    options={Produits}
                    value={selectedProduit}
                    onChange={e => setSelectedProduit(e ? e : { quantite: 1 })}
                  />
                  <IoSyncOutline
                    className="ms-2"
                    style={{ cursor: 'pointer', fontSize: '1.2rem' }} // Adjust icon size and add pointer cursor
                    onClick={() => {
                      setRefresh(prev => prev + 1);
                    }}
                  />
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Quantité</Form.Label>
                <Form.Control
                  type="number"
                  value={selectedProduit.quantite || 1}
                  min={1}
                  onChange={e =>
                    setSelectedProduit({
                      ...selectedProduit,
                      quantite: e.target.value
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Prix HT</Form.Label>
                <Form.Control
                  type="number"
                  value={selectedProduit.prixHt || 0}
                  min={0}
                  onChange={e =>
                    setSelectedProduit({
                      ...selectedProduit,
                      prixHt: e.target.value
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>TVA</Form.Label>
                <Form.Control
                  type="number"
                  value={selectedProduit.tva || 0}
                  min={0}
                  onChange={e =>
                    setSelectedProduit({
                      ...selectedProduit,
                      tva: e.target.value
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Button
                variant="primary"
                onClick={() => {
                  console.log(selectedProduit);
                  if (typeOperation === 'modification') {
                    ModifierProduit(selectedProduit.value, selectedProduit);
                  } else {
                    AjouterProduit(selectedProduit);
                  }
                  setShow(false);
                }}
              >
                {typeOperation === 'modification' ? 'Modifier' : 'Ajouter'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

const DetailsProduit = ({
  setModalShow,
  setTotalPrixHT,
  setRecapTva,
  setProduitsAchat
}) => {
  const [listProduits, setlistProduits] = useState([]);
  const [produits, setProduits] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [ajoutProduitShow, setAjoutProduitShow] = useState(false);
  const [typeOperation, setTypeOperation] = useState('Ajout');
  const [produitModif, setProduitModif] = useState(null);

  const calculateRecapTva = produits => {
    const tvaRecap = {};

    produits.forEach(produit => {
      const { tva, prixHt, quantite } = produit;
      const base = prixHt * quantite;
      const montant = (base * tva) / 100;

      if (!tvaRecap[tva]) {
        tvaRecap[tva] = { tva, base: 0, montant: 0 };
      }

      tvaRecap[tva].base += base;
      tvaRecap[tva].montant += montant;
    });

    return Object.values(tvaRecap); // Convert the object to an array of objects
  };

  useEffect(() => {
    const prods = [];
    const fetchProduits = async () => {
      const response = await getProduits();
      console.log('produitsFetched : ', response);
      if (response.length > 0) {
        response.map(produit => {
          prods.push({
            label: produit.produit,
            value: produit.id,
            prixHt: produit.prixHt,
            tva: produit.tva
          });
        });
        console.log(prods);
        setlistProduits(prods);
      }
    };
    fetchProduits();
  }, [refresh]);

  useEffect(() => {
    setProduitsAchat(produits); // Pass the latest produits to the parent
  }, [produits]); // Trigger whenever produits changes

  const AjouterProduit = data => {
    const newProduit = { ...data, quantite: data.quantite || 1 };
    const updatedProduits = [...produits, newProduit];

    // Update the products state
    setProduits(updatedProduits);

    // Update totalPrixHT
    setTotalPrixHT(
      prevTotal => prevTotal + newProduit.prixHt * newProduit.quantite
    );

    // Calculate and update recap TVA
    const recapTva = calculateRecapTva(updatedProduits);
    setRecapTva(recapTva);
  };
  const retirerProduit = id => {
    const updatedProduits = produits.filter(produit => produit.value !== id);

    // Update the products state
    setProduits(updatedProduits);

    // Recalculate totalPrixHT
    const newTotalPrixHT = updatedProduits.reduce(
      (sum, produit) => sum + produit.prixHt * produit.quantite,
      0
    );
    setTotalPrixHT(newTotalPrixHT);

    // Recalculate recap TVA
    const recapTva = calculateRecapTva(updatedProduits);
    setRecapTva(recapTva);
  };
  const ModifierProduit = (id, data) => {
    const updatedProduits = produits.map(produit =>
      produit.value === id ? { ...produit, ...data } : produit
    );

    // Update the products state
    setProduits(updatedProduits);

    // Recalculate totalPrixHT
    const newTotalPrixHT = updatedProduits.reduce(
      (sum, produit) => sum + produit.prixHt * produit.quantite,
      0
    );
    setTotalPrixHT(newTotalPrixHT);

    // Recalculate recap TVA
    const recapTva = calculateRecapTva(updatedProduits);
    setRecapTva(recapTva);

    setAjoutProduitShow(false);
  };

  const editerProduit = produit => {
    setTypeOperation('modification');
    setProduitModif(produit);
    console.log(produitModif);
    setAjoutProduitShow(true);
  };
  const ModifierQuantite = (id, quantite) => {
    const updatedProduits = produits.map(produit =>
      produit.value === id ? { ...produit, quantite } : produit
    );

    // Update the products state
    setProduits(updatedProduits);

    // Recalculate totalPrixHT
    const newTotalPrixHT = updatedProduits.reduce(
      (sum, produit) => sum + produit.prixHt * produit.quantite,
      0
    );
    setTotalPrixHT(newTotalPrixHT);

    // Recalculate recap TVA
    const recapTva = calculateRecapTva(updatedProduits);
    setRecapTva(recapTva);
  };

  const columns = [
    {
      accessorKey: 'reference',
      header: 'Désignation',
      meta: {
        headerProps: {
          className: 'text-start text-900 ',
          style: { minWidth: '200px' }
        },
        cellProps: {
          className: 'ps-2 text-end w-5 fw-semibold',
          style: { minWidth: '100px' }
        }
      },
      //"xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x"
      cell: ({ row: { original } }) => {
        const { value, label } = original;
        return (
          <div className="d-flex">
            <p className="mb-0 me-2">{value}</p>
            <div>{label}</div>
          </div>
        );
      }
    },
    {
      accessorKey: 'quantite',
      header: 'Quantité',
      meta: {
        headerProps: {
          className: 'text-start text-900 me-1',
          style: { maxWidth: '50px' }
        },
        cellProps: {
          className: 'text-start fw-semibold ps-1',
          style: { maxWidth: '50px' }
        }
      },
      //"xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x"
      cell: ({ row: { original } }) => {
        const { quantite, value } = original;
        return (
          <Form.Control
            type="number"
            value={quantite}
            min={1}
            onChange={e => {
              ModifierQuantite(value, e.target.value);
            }}
          />
        );
      }
    },
    {
      accessorKey: 'TTC',
      header: 'Prix HT',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-4 text-start w-2 fw-semibold'
        }
      },
      cell: ({ row: { original } }) => {
        const { prixHt } = original;
        return (
          <div>
            <p className="mb-0">{prixHt}</p>
          </div>
        );
      }
    },
    {
      accessorKey: 'TVA',
      header: 'TVA',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'text-start w-5 fw-semibold'
        }
      },
      cell: ({ row: { original } }) => {
        const { tva } = original;
        return (
          <div className="text-start">
            <p className="mb-0">{tva} %</p>
          </div>
        );
      }
    },
    {
      accessorKey: 'TTHTVA',
      header: 'TOTAL HT',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end fw-semibold'
        }
      },
      cell: ({ row: { original } }) => {
        const { quantite, prixHt } = original;
        return (
          <div className="text-start">{(prixHt * quantite).toFixed(3)}</div>
        );
      }
    },
    {
      accessorKey: 'TOTAL TTC',
      header: 'TOTAL TTC',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end fw-semibold'
        }
      },
      cell: ({ row: { original } }) => {
        const { tva, prixHt, quantite } = original;
        return (
          <div className="text-start">
            <p className="mb-0">
              {(prixHt * quantite * (1 + tva / 100)).toFixed(3)}
            </p>
          </div>
        );
      }
    },
    {
      accessorKey: 'ACTIONS',
      header: 'ACTIONS',
      meta: {
        headerProps: {
          className: 'text-center text-900 fs-0'
        },
        cellProps: {
          className: '',
          style: { paddingLeft: '0px' }
        }
      },
      cell: ({ row: { original } }) => {
        const { value } = original;
        return (
          <div className="d-flex align-items-center gap-2 justify-content-end">
            <Button
              variant="outline-primary"
              onClick={() => {
                editerProduit(original);
              }}
            >
              <MdEdit style={{ color: 'blue' }} />
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => retirerProduit(value)}
            >
              <FaTrash style={{ color: 'red' }} />
            </Button>
          </div>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: produits,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 90000,
    selectionColumnWidth: 52
  });

  return (
    <>
      <Card>
        <AdvanceTableProvider {...table}>
          <Card.Body>
            <AdvanceTable
              headerClassName="bg-body-tertiary align-middle"
              rowClassName="btn-reveal-trigger align-middle"
              tableProps={{
                size: 'sm',
                className: 'fs-10 mb-0 overflow-hidden'
              }}
              // onRowClick={row => handleLignes(row)}
              fixedHeader={true}
            />
          </Card.Body>
          <Card.Footer>
            <div className="d-flex justify-content-between align-items-center">
              <Button
                variant="outline-primary"
                className="fs-0"
                onClick={() => {
                  if (ajoutProduitShow) {
                    setAjoutProduitShow(false);
                  } else {
                    setTypeOperation('Ajout');
                    setAjoutProduitShow(true);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={ajoutProduitShow ? 'times' : 'plus'}
                  className="me-2"
                />
                {ajoutProduitShow ? 'Fermer' : 'Ajouter un produit'}
              </Button>
              <AdvanceTableFooter rowInfo {...table} />
            </div>
          </Card.Footer>
        </AdvanceTableProvider>
      </Card>

      {ajoutProduitShow && (
        <ProduitAjout
          Produits={listProduits}
          setModalShow={setModalShow}
          setRefresh={setRefresh}
          AjouterProduit={AjouterProduit}
          show={ajoutProduitShow}
          setShow={setAjoutProduitShow}
          typeOperation={typeOperation}
          ModifierProduit={ModifierProduit}
          produitAModifier={produitModif}
        />
      )}
    </>
  );
};

ProduitAjout.propTypes = {
  setShow: PropTypes.func,
  Produits: PropTypes.array,
  AjouterProduit: PropTypes.func,
  setModalShow: PropTypes.func,
  setRefresh: PropTypes.func,
  produitAModifier: PropTypes.object,
  typeOperation: PropTypes.string,
  ModifierProduit: PropTypes.func
};

DetailsProduit.propTypes = {
  setModalShow: PropTypes.func,
  setTotalPrixHT: PropTypes.func,
  setRecapTva: PropTypes.func,
  update: PropTypes.number,
  setProduitsAchat: PropTypes.func
};

export default DetailsProduit;
